export default "__VITE_ASSET__95f4c21a__"